import { SizeType, type Status, Tag, Tooltip } from "@snapchat/snap-design-system";
import { type TagSizeType } from "@snapchat/snap-design-system/es/components/Tag";
import { type FC } from "react";

export interface TagType<TagText> {
    text: TagText;
    status?: Status;
}

interface TagWithTooltipProps<TagText> {
    tag: TagType<TagText>;
    tooltipText: React.ReactNode | string;
    className?: string;
    size?: TagSizeType;
}

const TagWithTooltip: FC<TagWithTooltipProps<string>> = ({ tag, tooltipText, className, size = SizeType.SMALL }) => (
    <Tooltip content={tooltipText}>
        <span>
            <Tag size={size} status={tag.status} className={className}>
                {tag.text}
            </Tag>
        </span>
    </Tooltip>
);

export { TagWithTooltip };
